import Layout from '../../views/layouts/index'
const materialRouter = {
  path: '/',
  component: Layout,
  redirect: '/material',
  alwaysShow: true,
  name: 'material',
  children: [
    {
      path: 'material',
      component: () => import('../../views/material/index'),
      name: 'material_index',
    },
    {
      path: 'material/detail',
      component: () => import('../../components/materialDetail'),
      name: 'material_detail',
      meta:{activeMenu:'/material'}
    }
  ]
}

export default materialRouter



// WEBPACK FOOTER //
// ./src/router/modules/material.js